(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wtpb-form-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  const observed = new WeakSet();
  function repairLabels(root) {
    root.querySelectorAll('label[for]').forEach(label => {
      const name = label.getAttribute('for');
      const field = Array.from(label.parentElement.querySelectorAll('textarea'))
        .find(input => input.name === name && !input.id);
      if (field && !root.getElementById(name)) field.id = name;
    });
  }
  function connect() {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const root = host.shadowRoot;
      if (!root || observed.has(root)) return;
      observed.add(root);
      repairLabels(root);
      new MutationObserver(() => repairLabels(root))
        .observe(root, {childList: true, subtree: true});
    });
  }
  new MutationObserver(connect).observe(document.body, {childList: true, subtree: true});
  customElements.whenDefined('shopify-forms-embed').then(connect);
  connect();
  let attempts = 0;
  const timer = window.setInterval(() => {
    connect();
    if (++attempts >= 50) window.clearInterval(timer);
  }, 200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-google-review-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = { enabled: true, apiKey: 'AIzaSyA54zpQ2m3alkOxIcGE-3HUvte49j6AA90', placeId: 'ChIJVR_nN-OaFo8R4D77HDGAP1Q' };
    if (!config.enabled || !config.apiKey || !config.placeId) return;
    let pending;
    function loadPlaces() {
      if (window.google?.maps?.importLibrary) return window.google.maps.importLibrary('places');
      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Google unavailable')), 12000);
        window.wtpbGoogleReviewsReady = () => {
          clearTimeout(timeout);
          window.google.maps.importLibrary('places').then(resolve, reject);
        };
        const script = document.createElement('script');
        const url = new URL('https://maps.googleapis.com/maps/api/js');
        url.search = new URLSearchParams({key:config.apiKey, v:'quarterly', loading:'async', callback:'wtpbGoogleReviewsReady'});
        script.src = url.href;
        script.async = true;
        script.onerror = () => { clearTimeout(timeout); reject(new Error('Google unavailable')); };
        document.head.append(script);
      });
    }
    function getReviews() {
      if (!pending) pending = (async () => {
        const { Place } = await loadPlaces();
        const place = new Place({id:config.placeId});
        await place.fetchFields({fields:['rating','userRatingCount','googleMapsURI','attributions']});
        if (!Number.isInteger(place.userRatingCount) || place.userRatingCount < 0) throw new Error('No count');
        if (place.userRatingCount > 0 && (!Number.isFinite(place.rating) || place.rating < 1 || place.rating > 5)) throw new Error('No rating');
        return place;
      })();
      return pending;
    }
    async function update(root) {
      try {
        const place = await getReviews();
        root.dataset.googleStatus = 'ready';
        const link = root.querySelector('.wtpb-google-summary__link');
        if (place.googleMapsURI) {
          const url = new URL(place.googleMapsURI);
          if (url.protocol === 'https:' && /(^|\.)google\.com$/.test(url.hostname)) link.href = url.href;
        }
        if (place.userRatingCount) link.setAttribute('aria-label', root.dataset.googleLabel.replace('__RATING__', place.rating.toFixed(1)).replace('__COUNT__', place.userRatingCount.toLocaleString()));
        const rating = root.querySelector('[data-google-rating]');
        rating.textContent = place.userRatingCount ? place.rating.toFixed(1) : '';
        root.querySelector('[data-google-star]').hidden = !place.userRatingCount;
        root.querySelector('[data-google-count]').textContent = place.userRatingCount.toLocaleString();
        const credit = root.querySelector('[data-google-attributions]');
        for (const attribution of place.attributions || []) {
          const item = document.createElement('a');
          item.textContent = attribution.provider || '';
          if (attribution.providerURI) {
            try {
              const url = new URL(attribution.providerURI);
              if (url.protocol === 'https:' || url.protocol === 'http:') item.href = url.href;
            } catch (_) {}
          }
          item.target = '_blank';
          item.rel = 'noopener';
          credit.append(item, ' ');
        }
        root.querySelector('[data-google-fallback]').hidden = true;
        root.querySelector('[data-google-result]').hidden = false;
      } catch (_) {
        root.dataset.googleStatus = 'unavailable';
      }
    }
    const roots = document.querySelectorAll('[data-wtpb-google-summary]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          update(entry.target);
        }
      });
      roots.forEach(root => observer.observe(root));
    } else roots.forEach(update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-primary-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(nav) {
    if (nav.dataset.initialized) return;
    nav.dataset.initialized = 'true';
    const groups = [...nav.querySelectorAll('details')];
    const closeAll = () => groups.forEach(group => { group.open = false; });
    groups.forEach(group => {
      group.addEventListener('toggle', () => {
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
      });
      group.addEventListener('keydown', event => {
        if (event.key === 'Escape' && group.open) {
          event.preventDefault();
          group.open = false;
          group.querySelector('summary').focus();
        }
        if (event.key === 'ArrowDown' && event.target.tagName === 'SUMMARY') {
          event.preventDefault();
          group.open = true;
          group.querySelector('a')?.focus();
        }
      });
      group.addEventListener('focusout', () => {
        setTimeout(() => { if (!group.contains(document.activeElement)) group.open = false; }, 0);
      });
    });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) closeAll(); });
    window.addEventListener('resize', closeAll);
  }
  document.querySelectorAll('.wtpb-shopnav').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.wtpb-shopnav').forEach(initialize));
})();

(() => {
  const triggerSelector = '.js-mobile-menu-icon';
  const drawerSelector = '.header-navigation';
  const panelSelector = '.navigation__container';
  function updateControls() {
    const drawer = document.querySelector(drawerSelector);
    const panel = drawer?.querySelector(panelSelector);
    if (!panel) return;
    panel.id = panel.id || 'wtpb-menu-drawer';
    const open = drawer.classList.contains('header-navigation--open');
    document.querySelectorAll(triggerSelector).forEach(button => {
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('aria-expanded', String(open));
    });
  }
  function setOpen(open, restoreFocus) {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;
    drawer.classList.toggle('header-navigation--open', open);
    document.body.classList.toggle('mobile-menu-open', open);
    updateControls();
    if (!open && restoreFocus) document.querySelector(triggerSelector)?.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;
    const open = drawer.classList.contains('header-navigation--open');
    if (target.closest(triggerSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(!open, false);
      return;
    }
    if (target.closest('.js-close-mobile-menu')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(false, true);
      return;
    }
    if (open && !drawer.querySelector(panelSelector)?.contains(target)) setOpen(false, false);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.querySelector(drawerSelector)?.classList.contains('header-navigation--open')) {
      event.preventDefault();
      setOpen(false, true);
    }
  });
  const routeLabel = document.querySelector('[data-wtx-route-nav-label]')?.dataset.wtxRouteNavLabel;
  if (routeLabel) document.querySelectorAll('.header-navigation a, .customer-account__menu a').forEach(link => {
    if (link.getAttribute('href') === '/pages/delivery-routes' && !link.querySelector('svg')) link.textContent = routeLabel;
  });
  updateControls();
  document.addEventListener('shopify:section:load', updateControls);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-trustreviews-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const openProductReviews = (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (!(event.target instanceof Element)) return;
      const rating = event.target.closest('.tr-collection-product-rating');
      if (!rating || !rating.dataset.trProductUrl) return;
      const target = new URL(rating.dataset.trProductUrl, window.location.origin);
      if (target.origin !== window.location.origin) return;
      target.hash = 'trustreviewsFrame';
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(target.href);
    };
    document.addEventListener('click', openProductReviews, true);
    document.addEventListener('keydown', openProductReviews, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtx-route-calendar"] && !Shopify.designMode) return;
  try {
    (() => {
  const routeKeys = ['dfw', 'basin', 'north', 'nm', 'local'];
  const central = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  const display = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
  const localDisplay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
  const timeDisplay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit' });
  const validISO = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const date = new Date(`${value}T12:00:00Z`);
    return !Number.isNaN(date.valueOf()) && date.toISOString().slice(0, 10) === value;
  };
  const validTime = value => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value || '');
  const calculate = (runs, now = new Date()) => {
    const parts = Object.fromEntries(central.formatToParts(now).map(part => [part.type, part.value]));
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const clock = `${parts.hour}:${parts.minute}`;
    const processed = runs.map(run => {
      const validDates = Object.fromEntries(routeKeys.filter(key => validISO(run.dates?.[key])).map(key => [key, run.dates[key]]));
      const remaining = Object.values(validDates).filter(date => date >= today).sort();
      const serviceDates = Object.values(validDates).sort();
      const cutoffValid = validISO(run.cutoff) && validTime(run.cutoffTime) && (!serviceDates.length || run.cutoff <= serviceDates[0]);
      const cutoffState = !cutoffValid ? 'unknown' : today > run.cutoff || (today === run.cutoff && clock >= run.cutoffTime) ? 'passed' : 'open';
      return { ...run, validDates, remaining, cutoffState };
    });
    const confirmed = processed.filter(run => run.status === 'confirmed');
    const active = confirmed.filter(run => run.remaining.length).sort((a, b) => a.remaining[0].localeCompare(b.remaining[0]))[0];
    const futureByRoute = Object.fromEntries(routeKeys.map(key => [key, confirmed.filter(run => run.validDates[key] >= today).map(run => ({ date: run.validDates[key], cutoffState: run.cutoffState, runId: run.id })).sort((a, b) => a.date.localeCompare(b.date))]));
    return { today, clock, activeId: active?.id || null, runs: processed, futureByRoute };
  };
  const root = () => document.querySelector('[data-wtx-calendar]');
  const readRuns = calendar => Array.from(calendar.querySelectorAll('[data-wtx-run]')).map(element => ({
    id: element.dataset.runId, status: element.dataset.status, cutoff: element.dataset.cutoff, cutoffTime: element.dataset.cutoffTime,
    dates: Object.fromEntries(Array.from(element.querySelectorAll('[data-wtx-route-date]')).map(time => [time.dataset.wtxRouteDate, time.getAttribute('datetime')]))
  }));
  const dateText = iso => display.format(new Date(`${iso}T12:00:00Z`));
  const localDeliveries = (runs, now = new Date()) => {
    const state = calculate(runs, now);
    const seen = new Set();
    return state.futureByRoute.local.filter(item => {
      if (seen.has(item.date)) return false;
      seen.add(item.date);
      return true;
    }).slice(0, 2).map(item => {
      const run = state.runs.find(candidate => candidate.id === item.runId);
      return { ...item, dateLabel: localDisplay.format(new Date(`${item.date}T12:00:00Z`)), cutoff: run.cutoff, cutoffTime: run.cutoffTime };
    });
  };
  const routeDates = key => {
    const calendar = root();
    if (!calendar) return '';
    const state = calculate(readRuns(calendar));
    const dates = state.futureByRoute[key] || [];
    if (!dates.length) return calendar.dataset.datesUnconfirmed;
    return [...new Set(dates.map(item => {
      const suffix = item.cutoffState === 'passed' ? calendar.dataset.cutoffSuffix : item.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknownSuffix : '';
      return `${dateText(item.date)}${suffix ? ` (${suffix})` : ''}`;
    }))].join(' · ');
  };
  let selectedRoute = 'all';
  const nextDelivery = (runs, key, now = new Date()) => {
    const state = calculate(runs, now);
    const item = state.futureByRoute[key]?.[0];
    if (!item) return null;
    const run = state.runs.find(candidate => candidate.id === item.runId);
    return { ...item, cutoff: run.cutoff, cutoffTime: run.cutoffTime };
  };
  const showNext = () => {
    const calendar = root(), panel = document.querySelector('[data-wtx-route-next]');
    if (!calendar || !panel) return;
    panel.hidden = selectedRoute === 'all';
    if (panel.hidden) return;
    const button = Array.from(document.querySelectorAll('.wtx-route-filter')).find(item => item.dataset.route === selectedRoute);
    panel.style.setProperty('--route-color', button?.style.getPropertyValue('--route-color') || 'var(--gold)');
    panel.querySelector('[data-wtx-next-name]').textContent = button?.textContent.trim() || '';
    const item = nextDelivery(readRuns(calendar), selectedRoute);
    const date = panel.querySelector('[data-wtx-next-date]'), cutoff = panel.querySelector('[data-wtx-next-cutoff]'), note = panel.querySelector('[data-wtx-next-note]');
    const help = panel.querySelector('[data-wtx-next-help]'), details = panel.querySelector('[data-wtx-next-details]');
    help.hidden = Boolean(item && item.cutoffState === 'open');
    details.hidden = !item;
    if (!item) {
      date.textContent = calendar.dataset.nextEmpty;
      cutoff.textContent = '';
      note.textContent = selectedRoute === 'frontier' ? calendar.dataset.nextFrontier : '';
      return;
    }
    date.textContent = `${calendar.dataset.nextLabel}: ${localDisplay.format(new Date(`${item.date}T12:00:00Z`))}`;
    cutoff.textContent = item.cutoffState === 'passed' ? calendar.dataset.cutoffPassed : item.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknown : `${calendar.dataset.orderBy} ${dateText(item.cutoff)} · ${timeDisplay.format(new Date(`2000-01-01T${item.cutoffTime}:00Z`))} ${calendar.dataset.central}`;
    const runElement = Array.from(calendar.querySelectorAll('[data-wtx-run]')).find(element => element.dataset.runId === item.runId);
    note.textContent = [runElement?.dataset.publicLabel, selectedRoute === 'nm' ? calendar.dataset.nextNm : ''].filter(Boolean).join(' · ');
    details.href = `#wtx-run-${item.runId}`;
  };
  const selectRoute = key => { selectedRoute = key; showNext(); };
  const refresh = () => {
    const calendar = root();
    if (!calendar) return;
    const state = calculate(readRuns(calendar));
    const shouldOpen = calendar.dataset.currentDay !== state.today;
    const elements = Array.from(calendar.querySelectorAll('[data-wtx-run]'));
    for (const run of state.runs) {
      const element = elements.find(item => item.dataset.runId === run.id);
      if (!element) continue;
      if (shouldOpen) element.open = run.id === state.activeId;
      element.dataset.completed = String(run.status === 'confirmed' && !run.remaining.length);
      if (run.status !== 'confirmed') continue;
      const label = element.querySelector('[data-wtx-run-label]');
      if (label) label.textContent = run.remaining.length ? (element.dataset.publicLabel || calendar.dataset.confirmed) : calendar.dataset.archive;
      const status = element.querySelector('[data-wtx-cutoff-status]');
      if (status) status.textContent = run.cutoffState === 'passed' ? calendar.dataset.cutoffPassed : run.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknown : '';
      const help = element.querySelector('[data-wtx-cutoff-help]');
      if (help) help.hidden = run.cutoffState === 'open';
    }
    if (shouldOpen) {
      const upcoming = state.runs.filter(run => run.status === 'confirmed' && run.remaining.length).sort((a, b) => a.remaining[0].localeCompare(b.remaining[0]));
      const privateRuns = state.runs.filter(run => run.status !== 'confirmed');
      const completed = state.runs.filter(run => run.status === 'confirmed' && !run.remaining.length);
      const list = calendar.querySelector('.wtx-months');
      if (list) [...upcoming, ...privateRuns, ...completed].forEach(run => {
        const element = elements.find(item => item.dataset.runId === run.id);
        if (element) list.appendChild(element);
      });
    }
    const empty = calendar.querySelector('[data-wtx-empty]');
    if (empty) empty.hidden = Boolean(state.activeId);
    calendar.dataset.currentDay = state.today;
    showNext();
    const localDates = localDeliveries(readRuns(calendar));
    document.querySelectorAll('[data-wtx-local-dates]').forEach(wrapper => {
      ['[data-wtx-local-next]', '[data-wtx-local-following]'].forEach((selector, index) => {
        const card = wrapper.querySelector(selector);
        if (!card) return;
        const item = localDates[index];
        card.hidden = !item;
        if (!item) return;
        const date = card.querySelector('[data-wtx-local-date]');
        if (date) {
          date.textContent = item.dateLabel;
          date.setAttribute('datetime', item.date);
        }
        const cutoff = card.querySelector('[data-wtx-local-cutoff]');
        if (cutoff) cutoff.textContent = item.cutoffState === 'passed' ? calendar.dataset.cutoffPassed : item.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknown : `${calendar.dataset.orderBy} ${dateText(item.cutoff)} · ${timeDisplay.format(new Date(`2000-01-01T${item.cutoffTime}:00Z`))} ${calendar.dataset.central}`;
        const help = card.querySelector('[data-wtx-local-help]');
        if (help) help.hidden = item.cutoffState === 'open';
      });
      const localEmpty = wrapper.querySelector('[data-wtx-local-empty]');
      if (localEmpty) localEmpty.hidden = Boolean(localDates.length);
    });
  };
  const hasUpcoming = key => { const calendar = root(); return Boolean(calendar && calculate(readRuns(calendar)).futureByRoute[key]?.length); };
  window.wtxRouteCalendar = { calculate, routeDates, refresh, hasUpcoming, localDeliveries, nextDelivery, selectRoute };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-wtx-next-details]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target) target.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:block:select', event => {
    const calendar = root();
    if (!calendar) return;
    const selected = Array.from(calendar.querySelectorAll('[data-wtx-run]')).find(element => element.dataset.runId === event.detail?.blockId);
    if (selected) selected.open = true;
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.setInterval(() => { if (!document.hidden) refresh(); }, 60000);
})();
  } catch(e) { console.error(e); }
})();

})();
